export default __webpack_public_path__ + "static/media/NE.9ca7c37c.svg";